<template>
  <div class="flex min-w-0 items-center gap-2">
    <div class="min-w-0 grow">
      <span v-if="showName" class="text-label-large text-on-surface-variant mb-1">{{
        teamName
      }}</span>
      <span v-if="portalUrl" class="text-body-medium line-clamp-1 break-all select-all">{{
        portalUrl
      }}</span>
      <span v-else-if="settled" class="text-body-medium text-on-surface-variant">
        {{ $t('portal.link.empty') }}
      </span>
    </div>
    <BaseIconButton
      v-if="portalUrl"
      v-tooltip="$t('portal.display.action')"
      icon="qr_code"
      size="S"
      @click="openDisplay"
    />
    <BaseIconButton
      v-if="portalUrl"
      v-tooltip="$t('common.copy')"
      icon="content_copy"
      size="S"
      @click="copyLink"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import { ApiRequestStatus } from '@/core/models/api/api-request-status'
  import { useTeamPortal } from '@/modules/portal/composables/use-team-portal'
  import { useSnackStore } from '@/stores/snack.store'

  const props = defineProps<{
    teamId: string
    teamName: string
    showName?: boolean
  }>()

  const { t } = useI18n()
  const router = useRouter()
  const snackStore = useSnackStore()
  const { portalUrl, status } = useTeamPortal(() => props.teamId)

  const settled = computed(
    () => status.value === ApiRequestStatus.Success || status.value === ApiRequestStatus.Error,
  )

  const openDisplay = () => {
    const { href } = router.resolve({
      name: 'team-portal-display',
      params: { teamId: props.teamId },
    })
    window.open(href, '_blank', 'noopener,noreferrer')
  }

  const copyLink = () => {
    if (!portalUrl.value) {
      return
    }
    navigator.clipboard.writeText(portalUrl.value)
    snackStore.showInfo(t('portal.link.copied'))
  }
</script>
